import React, { useContext, useEffect, useState } from 'react';
import {
  CButton,
  CCard,
  CCardHeader,
  CCol,
  CRow,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CModalTitle
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import DownloadExcel from 'src/reusables/DownloadExcel';
import { useLocation, useNavigate } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import formatter from 'src/reusables/formatter';
import { getAll, getForDownload } from 'src/services/Invoices';
import { Toaster } from 'src/components/Toaster';
import ls from 'local-storage';
import { DateRangePicker } from 'react-date-range';
import { format, isWeekend } from 'date-fns';
import Select, { components } from 'react-select';
import Authentication, { AUTH_KEY } from 'src/utils/auth/Authentication';
import { AuthContext } from 'src/App';
import Moment from 'moment';
function Invoices() {
  const [dataRows, setDataRows] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);
  const [drModal, setDrModal] = useState(false);
  const [refetch, setRefetch] = useState(false);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [color, setColor] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [excelRows, setExcelRows] = useState([]);
  const [excelColumns, setExcelColumns] = useState([]);
  const [filterOptions, setFilterOptions] = useState([
    { label: 'All', value: 'All' },
    { label: 'Paid', value: 'Paid' },
    { label: 'Outstanding', value: 'Outstanding' },
    { label: 'Overdue', value: 'Overdue' }
  ]);
  const [selectedFilter, setSelectedFilter] = useState({ label: 'All', value: 'All' });
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(`${Moment(new Date()).startOf('month')}`),
      endDate: new Date()
    }
  ]);
  const endDay = Moment(new Date()).format('YYYY-MM-DD');
  const max = new Date(endDay);
  const startDay = Moment(new Date('Jan 1 2023')).format('YYYY-MM-DD');
  const Auth = useContext(AuthContext);
  const useWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    const comparison = width / height;
    const [windowDimensions, setWindowDimensions] = useState({
      width,
      height,
      comparison
    });

    useEffect(() => {
      function handleResize() {
        const { innerWidth: width, innerHeight: height } = window;
        const comparison = width / height;
        setWindowDimensions({ width, height, comparison });
      }

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
  };

  const { height, width, comparison } = useWindowDimensions();
  async function fetchDownloadData(selectedFilter) {
    setLoadingDownload(true);
    await getForDownload(selectedFilter.value).then((res) => {
      const rows =
        res.invoices &&
        res.invoices.map((item, i) => {
          return {
            no: i + 1,
            id: item.id,
            invoiceNo: item.invoice_number,
            invoiceDate: formatter('dateOnly', item.invoice_date),
            rawInvoiceDate: item.invoice_date.substring(0, 10),
            customerName: item.customer,
            paymentMethod: item.payment_type,
            notes: item.notes,
            paidAt: item.paid_at ? formatter('dateOnly', item.paid_at) : 'Belum Lunas',
            dueDate: formatter('dateOnly', item.due_date),
            rawDueDate: item.due_date.substring(0, 10),
            grandTotal: formatter('currency', item.grand_total ?? 0),
            salesID: item.sales_id,
            salesName: item.salesName,
            uuid: item.uuid,
            ct: item.payment_type,
            recipientName: item.recipient_name,
            recipientPhone: item.recipient_phone,
            recipientAddress: item.recipient_address,
            remaining: item.deleted_at ? 0 : item.remaining ?? 0,
            productName: item.productName, // Added product name
            qtyPcs: item.deleted_at ? 0 : item.qty_pcs ?? 0, // Added quantity in pieces
            qtyRoll: item.deleted_at ? 0 : item.qty_roll ?? 0, // Added quantity in rolls
            unitPrice: formatter('currency', item.unit_price ?? 0), // Added unit price
            idetTotal: formatter('currency', item.idetTotal ?? 0), // Added invoice detail total
            receiptDate: item.receiptDate ? formatter('dateOnly', item.receiptDate) : null, // Added receipt date
            paymentAmount: item.paymentAmount ? formatter('currency', item.paymentAmount) : null, // Added payment amount
            bankName: item.bankName, // Added bank name
            deletedAt: item.deleted_at,
            rawGrandTotal: item.deleted_at ? 0 : item.grand_total ?? 0,
            rawUnitPrice: item.deleted_at ? 0 : item.unit_price ?? 0,
            rawIdetTotal: item.deleted_at ? 0 : item.idetTotal ?? 0,
            rawPaymentAmount: item.deleted_at ? 0 : item.paymentAmount ?? 0,
            rawRemaining: item.deleted_at ? 0 : item.remaining ?? 0
          };
        });

      setExcelRows(rows);

      const columns = [
        { field: 'no', headerName: 'No', width: 50 },
        { field: 'invoiceNo', headerName: 'Invoice #', width: 200 },
        { field: 'rawInvoiceDate', headerName: 'Tanggal', width: 200 },
        { field: 'customerName', headerName: 'Customer', width: 200 },
        { field: 'salesName', headerName: 'Sales', width: 200 },
        { field: 'productName', headerName: 'Product Name', width: 200 }, // Added product name column
        { field: 'qtyPcs', headerName: 'Quantity (Pcs)', width: 150 }, // Added quantity in pieces column
        { field: 'qtyRoll', headerName: 'Quantity (Roll)', width: 150 }, // Added quantity in rolls column
        { field: 'rawUnitPrice', headerName: 'Unit Price', width: 150 }, // Added unit price column
        { field: 'rawIdetTotal', headerName: 'Subtotal', width: 150 }, // Added invoice detail total column
        { field: 'rawGrandTotal', headerName: 'Grand Total', width: 200 },
        { field: 'ct', headerName: 'Cash/Tempo', width: 200 },
        { field: 'dueDate', headerName: 'Jatuh Tempo', width: 200 },
        { field: 'paidAt', headerName: 'Tanggal Lunas', width: 200 },
        { field: 'receiptDate', headerName: 'Receipt Date', width: 200 }, // Added receipt date column
        { field: 'bankName', headerName: 'Recent Bank Name', width: 200 }, // Added bank name column
        { field: 'rawPaymentAmount', headerName: 'Total Paid Amount', width: 200 },
        { field: 'rawRemaining', headerName: 'Remaining', width: 200 }, // Added payment amount column
        { field: 'notes', headerName: 'Notes', width: 200 }
      ];
      setExcelColumns(columns);
      setLoadingDownload(false);
    });
  }
  async function fetchMainData(selectedFilter) {
    setLoading(true);
    const res = await getAll(selectedFilter.value);

    const rows =
      res.invoices &&
      res.invoices.map((item, i) => {
        return {
          no: i + 1,
          id: item.id,
          invoiceNo: item.invoice_number,
          invoiceDate: formatter('dateOnly', item.invoice_date),
          rawInvoiceDate: item.invoice_date.substring(0, 10),
          customerName: item.customer,
          paymentMethod: item.payment_type,
          notes: item.notes,
          paidAt: item.paid_at ? formatter('dateOnly', item.paid_at) : 'Belum Lunas',
          dueDate: formatter('dateOnly', item.due_date),
          rawDueDate: item.due_date.substring(0, 10),
          grandTotal: formatter('currency', item?.grand_total ?? 0),
          rawGrandTotal: item?.grand_total ?? 0,
          salesID: item.sales_id,
          salesName: item.salesName,
          uuid: item.uuid,
          recipientName: item.recipient_name,
          recipientPhone: item.recipient_phone,
          recipientAddress: item.recipient_address,
          deletedAt: item.deleted_at
        };
      });

    setDataRows(rows);

    const columns = [
      { field: 'no', headerName: 'No', width: '50' },
      { field: 'invoiceNo', headerName: 'Invoice #', width: 200 },
      { field: 'invoiceDate', headerName: 'Tanggal', width: 200 },
      { field: 'customerName', headerName: 'Customer', width: 200 },
      { field: 'salesName', headerName: 'Sales', width: 200 },
      { field: 'notes', headerName: 'Notes', width: 200 },
      { field: 'grandTotal', headerName: 'Grand Total', width: 200 },
      { field: 'dueDate', headerName: 'Jatuh Tempo', width: 200 },
      { field: 'paidAt', headerName: 'Tanggal Lunas', width: 200 }
    ];

    setDataColumns(columns);
    setLoading(false);
  }

  useEffect(() => {
    const newStartDay = formatter('SQLDate', dateRange[0].startDate);
    const newEndDay = formatter('SQLDate', dateRange[0].endDate);
    fetchMainData(selectedFilter);
    fetchDownloadData(selectedFilter);
  }, [selectedFilter]);
  useEffect(() => {
    if (location.state) {
      setSelectedFilter({ label: location.state, value: location.state });
    }
  }, [location]);
  function customDayContent(day) {
    let extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: '5px',
            width: '5px',
            borderRadius: '100%',
            background: 'orange',
            position: 'absolute',
            top: 2,
            right: 2
          }}
        />
      );
    }
    return (
      <div>
        <span
          style={{
            fontWeight: '600'
          }}
        >
          {format(day, 'd')}
        </span>
      </div>
    );
  }

  function handleRowClick(params) {
    navigate('/invoice-actions', { state: params.row });
  }

  return (
    <div style={{ color: 'black' }}>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? 'red'} />

      <CCard>
        <CCardHeader>
          <CRow className="mb-3">
            <CCol xs={7} lg={7}>
              <h4> Daftar Invoice </h4>
              <CCol>
                <Select
                  placeholder="Pilih Filter"
                  value={selectedFilter}
                  options={filterOptions}
                  onChange={(e) => {
                    setSelectedFilter(e);
                  }}
                  isDisabled={false}
                  feedbackInvalid="Required value"
                  required
                />
                {/* <CButton
                  className="ml-3 mb-3 btn btn-dark"
                  style={{ backgroundColor: '#306fba', border: 'none' }}
                  hover="true"
                  onClick={() => {
                    setDrModal(!drModal);
                    console.log(drModal);
                  }}
                >
                  <div>
                    {Moment(dateRange[0].startDate).format('ll')}
                    {' - '}
                    {Moment(dateRange[0].endDate).format('ll')}
                  </div>
                </CButton> */}
              </CCol>
            </CCol>
            <CModal visible={drModal}>
              <CModalHeader>
                {' '}
                <CModalTitle>Date Range</CModalTitle>
              </CModalHeader>
              <CModalBody>
                {' '}
                <CCol xs="12" lg="10">
                  <DateRangePicker
                    onChange={(item) => {
                      setDateRange([item.range1]);
                      ls.set('dateRange', item.range1);
                    }}
                    showSelectionPreview={true}
                    moveRangeOnFirstSelection={false}
                    months={1}
                    maxDate={max}
                    ranges={dateRange}
                    direction="vertical"
                    weekStartsOn={1}
                    calendarFocus="backwards"
                    preventSnapRefocus={true}
                    rangeColors={['#4E5B97']}
                    dayContentRenderer={customDayContent}
                  />
                </CCol>
              </CModalBody>
              <CModalFooter
                style={{
                  width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
                }}
              >
                <CButton style={{ backgroundColor: '#4E5B97', border: 'none' }} onClick={() => setDrModal(!drModal)}>
                  Close
                </CButton>
                <CButton
                  style={{ backgroundColor: '#4E5B97', border: 'none' }}
                  onClick={() => {
                    setRefetch(true);
                    setDrModal(false);
                  }}
                >
                  OK
                </CButton>
              </CModalFooter>
            </CModal>

            <CCol xs={5} lg={5} style={{ textAlign: 'right' }}>
              <CButton
                style={{ borderColor: 'primary' }}
                onClick={() => {
                  navigate('/invoice-actions');
                }}
              >
                Tambah
              </CButton>
              &nbsp;
              {/* {Auth.isAllowed(Auth.role[AUTH_KEY.export_reports]) && (
                <DownloadExcel
                  rows={dataRows}
                  columns={dataColumns}
                  excelName="Daftar Produk"
                  config={{ width: '20' }}
                />
              )} */}
              <DownloadExcel
                rows={excelRows}
                columns={excelColumns}
                loading={loadingDownload}
                excelName="Daftar Invoice"
                config={{ width: '20' }}
              />
            </CCol>
          </CRow>
        </CCardHeader>
        <div style={{ margin: '16px' }}>
          <DataGrid
            rows={dataRows}
            columns={dataColumns}
            onRowClick={handleRowClick}
            loading={loading}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 }
              }
            }}
            pageSizeOptions={[5, 10, 20, 25]}
            style={{ textAlign: 'center' }}
            getRowClassName={(params) => (params.row.deletedAt ? 'highlighted-row' : '')}
          />
        </div>
      </CCard>
    </div>
  );
}

export default Invoices;
